import { Picker } from '@react-native-picker/picker';
import { useRef } from 'react';
import {
  Platform,
  Pressable,
  StyleProp,
  StyleSheet,
  ViewStyle,
} from 'react-native';

import { TextBodySmall, TextFinePrint } from './StyledText';
import { TransparentView } from './Themed';
import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';

// options from 6:00 AM to 10:00 PM every 30 minutes, with AM and PM
const options = Array.from({ length: 16 }, (_, i) => {
  const hour = i + 6;
  const amPm = hour < 12 ? 'AM' : 'PM';
  return [
    `${hour % 12 === 0 ? 12 : hour % 12}:00 ${amPm}`,
    `${hour % 12 === 0 ? 12 : hour % 12}:30 ${amPm}`,
  ];
}).flat();

export default function TimeInput({
  style,
  label,
  value,
  onChange,
}: {
  style?: StyleProp<ViewStyle>;
  label?: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const theme = useColorScheme();

  const pickerRef = useRef<Picker<string>>(null);

  const open = () => {
    pickerRef.current?.focus();
  };

  return (
    <TransparentView style={style}>
      <Pressable
        style={[
          styles.inputContainer,
          {
            borderWidth: 2,
            borderColor: Colors[theme].lines,
            backgroundColor: Colors[theme].background,
          },
        ]}
        onPress={open}
      >
        {label ? (
          <TextFinePrint
            style={{
              // position: 'absolute',
              // top: 3,
              // left: 14,
              color: Colors[theme].textLowContrast,
            }}
            numberOfLines={1}
          >
            {label}
          </TextFinePrint>
        ) : null}
        <Picker
          dropdownIconColor={Colors[theme].text}
          style={{
            flex: 1,
            height: '100%',
            borderWidth: 0,
            padding: 0,
            ...Platform.select({
              web: { padding: 0 },
            }),
          }}
          ref={pickerRef}
          selectedValue={value}
          onValueChange={onChange}
        >
          {options.map((option) => (
            <Picker.Item
              label={option}
              value={option}
              key={`time-input-${option}`}
            />
          ))}
        </Picker>
      </Pressable>
    </TransparentView>
  );
}

const styles = StyleSheet.create({
  inputContainer: {
    height: 55,
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 11,
    paddingVertical: 10,
    paddingTop: 2,
  },
});
